import { useEffect, useState } from "react";
import { api, errDetail } from "../lib/api";
import { useApp } from "../lib/store";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export function SendEmailDialog({ open, onOpenChange, endpoint, defaultSubject, onSent }) {
  const { t } = useApp();
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) setSubject(defaultSubject || "");
  }, [open, defaultSubject]);

  const send = async () => {
    setSending(true);
    try {
      const r = await api.post(endpoint, { to, subject, message });
      toast.success(r.data.sent ? t("email_sent_ok") : t("email_simulated"));
      onSent?.();
      onOpenChange(false);
      setTo(""); setMessage("");
    } catch (e) {
      toast.error(errDetail(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Mail className="h-4 w-4" />{t("send_email")}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label className="text-xs text-gray-500">{t("recipient")} *</Label>
            <Input data-testid="email-to-input" type="email" placeholder="kunde@firma.de" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-gray-500">{t("subject")}</Label>
            <Input data-testid="email-subject-input" value={subject} onChange={(e) => setSubject(e.target.value)} />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-gray-500">{t("message")}</Label>
            <Textarea data-testid="email-message-input" rows={5} value={message} onChange={(e) => setMessage(e.target.value)} />
          </div>
          <Button className="w-full bg-[#1B2A4A] hover:bg-[#2a3d63] text-white" disabled={!to.includes("@") || sending}
            onClick={send} data-testid="email-send-btn">
            {sending ? "…" : t("send")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
